import _, {isString, map} from 'lodash';

import {isInteger} from '../../../libs/shared/helpers/src/typescript/typeHelpers';
import {updateConversationTrackers} from '../../helpers/models/conversationHelpers';
import {ConversationPatch} from '../../models/api/conversationPatchModel';
import {
  ConversationTrackerStagesEnum,
  ConversationTrackerStatusesEnum,
} from '../../models/api/conversationTrackerModel';
import {ThunkAction} from '../../store/appThunk';
import {updateConversationsAction} from '../../store/data/conversations/updateConversationsActions';
import {recordTeammateInteractionsAction} from '../../store/data/localPreferences/localPreferencesActions';

interface UpdateConversationTrackersActionOptions {
  add?: ReadonlyArray<number | string>;
  remove?: ReadonlyArray<number>;
  stage?: ConversationTrackerStagesEnum;
}

export function updateConversationTrackersAction(
  conversationId: number,
  options: UpdateConversationTrackersActionOptions,
): ThunkAction {
  return async (dispatch) => {
    // Locally, we only add the teammates to the conversations.
    // Visitors will be added by the server.
    const addTeammateIds = _(options.add)
      .map((t) => isInteger(t) && t)
      .compact()
      .value();

    // Update the conversation.
    await dispatch(
      updateConversationsAction(
        [conversationId],
        makeUpdateConversationTrackersPatch(options),
        updateConversationTrackers({
          ...options,
          add: addTeammateIds,
        }),
      ),
    );

    // Track interactions with these teammates.
    dispatch(recordTeammateInteractionsAction(addTeammateIds));
  };
}

function makeUpdateConversationTrackersPatch(
  options: UpdateConversationTrackersActionOptions,
): ConversationPatch {
  const addTrackers = map(options.add, (trackerId) => {
    const commonProps = {
      status: ConversationTrackerStatusesEnum.INBOX,
      stage: options.stage || ConversationTrackerStagesEnum.TRACKER,
    };

    // Visitor.
    if (isString(trackerId)) {
      return {
        teammateEmail: trackerId,
        ...commonProps,
      };
    }

    // teammate.
    return {
      teammateId: trackerId,
      ...commonProps,
    };
  });

  return {
    addTrackers,
    removeTrackers: options.remove,
  };
}
